import { render, staticRenderFns } from "./SchoolLayout.vue?vue&type=template&id=1b910e9a&scoped=true&"
import script from "./SchoolLayout.vue?vue&type=script&lang=js&"
export * from "./SchoolLayout.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLayout.vue?vue&type=style&index=0&id=1b910e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b910e9a",
  null
  
)

export default component.exports